// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"215":"d20b8e93","241":"0dddf890","818":"04df6b0e","827":"cddc2a67"}[chunkId] + ".js";
};